<template>
  <span>
    <span v-if="disabled"
          class="disabled">
      <i :class="icon"/>{{name}}
      <i class="el-icon-arrow-down el-icon--right"/>
    </span>
    <el-dropdown v-else
                 trigger="click"
                 @command="action"
                 class="dropdown-link">
      <span>
        <i :class="icon"/>{{name}}
        <i class="el-icon-arrow-down el-icon--right"/>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item v-for="(option, index) in options"
                          :key="index"
                          :command="index"
                          :disabled="option.disabled">
          {{option.name}}
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </span>
</template>

<script>
export default {
  props: {
    name: {
      required: true,
      type: String,
      default: '',
    },
    options: {
      type: Array,
      default() {
        return [];
      },
    },
    icon: {
      required: true,
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  name: 'Multiple',
  methods: {
    action(option) {
      this.$emit('action', option);
    },
  },
};
</script>

<style scoped lang="scss">
  .disabled {
    i { margin-right: 5px; }
    margin: 6px;
    cursor: default;
    padding: 5px 10px;
    border-radius: 3px;
    display: inline-block;
    color: $fb-grey-light-70;
    .el-icon-arrow-down {
      font-size: 12px;
      margin-left: 10px;
    }
  }
  .dropdown-link {
    margin: 6px;
    font-size: 13px;
    padding: 5px 10px;
    border-radius: 3px;
    display: inline-block;
    background-color: $fb-grey-light-94;
    span {
      color: $fb-grey-light-30;
      cursor: pointer;
      .el-icon-delete { margin-right: 5px; }
      .el-icon-arrow-down {
        margin-left: 10px;
        font-size: 12px;
      }
    }
  }
  .dropdown-link:hover {
    span { color: white; }
    background-color: $fb-red;
  }
</style>
